<template>
  <div id="home-menu" v-if="getEnums != null">
    <div class="sidebar sidebar-light sidebar-main sidebar-expand-md align-self-start">
      <div class="sidebar-content">
        <div class="card-sidebar-mobile">
          <div class="card-body p-0">
            <ul class="nav nav-sidebar" data-nav-type="accordion">
              <li class="nav-item-header mt-0">
                <div class="menu-title-custom">
                  {{ $t("homeMenu.account") }}
                </div>
                <i class="icon-menu"></i>
              </li>

              <li class="nav-item menu-account-block">
                <router-link class="nav-link" :to="{ name: 'myevents' }" exact>
                  <div class="menu-account-image" :style="'background-image: url(' + $store.getters.currentUser.image + '?width=200&height=200)'"></div>
                  <div class="menu-account-title">
                    <p>{{ $store.getters.currentUser.firstName + " " + $store.getters.currentUser.lastName }}</p>
                    <span>{{ $store.getters.currentUser.email }}</span>
                  </div>
                </router-link>
              </li>

              <li class="nav-item-header mt-0">
                <div class="menu-title-custom">
                  {{ $t("homeMenu.organization") }}
                </div>
                <i class="icon-menu"></i>
              </li>

              <!-- <li class="nav-item menu-organisation-block" v-for="(organization, index) in organizationList" :key="index">
                <a class="nav-link" @click="switchOrganization(organization.id)" style="cursor:pointer;" :class="organization.id == $route.params.organisation_id ? 'active' : ''">
                  <div class="menu-organisation-image flex-shrink-0" :style="'background-image: url(' + $imageus + organization.image + '?width=200&height=200)'"></div>
                  <div class="menu-organisation-title">
                    <p>{{ organization.title }}</p>
                    <span>{{ organization.planTitle }} {{ organization.eventCount + " events" }}</span>
                  </div>
                </a>
              </li> -->
              <li class="nav-item-header mt-0" v-if="organizationList.length > 5">
                <el-input v-model="searchTerm" placeholder="Ara..." autocomplete="off" @clear="searchTerm = null" clearable></el-input>
              </li>
              <li class="nav-item menu-organisation-list">
                <div class="menu-organisation-item" :class="organization.id == $route.params.organisation_id ? 'active' : ''" @click="switchOrganization(organization.id)" style="cursor:pointer;" v-for="(organization, index) in organizationListSearch" :key="index">
                  <div class="menu-organisation-image flex-shrink-0" :style="'background-image: url(' + $imageus + organization.image + '?width=200&height=200)'"></div>
                  <div class="menu-organisation-title">
                    <p>{{ organization.title }}</p>
                    <span>{{ organization.planTitle }} {{ organization.planTitle != null ? ' Plan,' : ''}} {{ organization.eventCount + " " + $t("organisation.event.event") }}</span>
                  </div>
                </div>
              </li>
              <li class="nav-item menu-organisation-block">
                <a class="nav-link create-organisation" style="cursor:pointer" @click="organizationDialog = true">
                  <span>
                    {{ $t("homeMenu.createOrganization") }}
                  </span>
                </a>
              </li>

              <li class="nav-item-header mt-0">
                <div class="menu-title-custom">
                  {{ $t("homeMenu.statutory") }}
                </div>
                <i class="icon-menu"></i>
              </li>

              <li class="nav-item menu-link-block">
                <a class="nav-link" href="#" @click.prevent="openAgreementDialog(6)" target="_blank">
                  <div class="menu-link-image">
                    <i class="fas fa-file"></i>
                  </div>
                  <div class="menu-link-title">
                    <p>
                      {{ $t("homeMenu.terms") }}
                    </p>
                  </div>
                </a>
              </li>

              <li class="nav-item menu-link-block">
                <a class="nav-link" href="#" @click.prevent="openAgreementDialog(2)" target="_blank">
                  <div class="menu-link-image">
                    <i class="fas fa-shield-alt"></i>
                  </div>
                  <div class="menu-link-title">
                    <p>
                      {{ $t("homeMenu.privacyPolicies") }}
                    </p>
                  </div>
                </a>
              </li>

              <li class="nav-item menu-link-block">
                <a class="nav-link" href="#" @click.prevent="openAgreementDialog(1)" target="_blank">
                  <div class="menu-link-image">
                    <i class="fas fa-clipboard-check"></i>
                  </div>
                  <div class="menu-link-title">
                    <p>
                      {{ $t("homeMenu.gdprText") }}
                    </p>
                  </div>
                </a>
              </li>

              <li class="nav-item menu-link-block">
                <a class="nav-link" href="#" @click.prevent="openAgreementDialog(9)" target="_blank">
                  <div class="menu-link-image">
                    <i class="fas fa-database"></i>
                  </div>
                  <div class="menu-link-title">
                    <p>
                      {{ $t("homeMenu.cookies") }}
                    </p>
                  </div>
                </a>
              </li>

              <li class="nav-item-header mt-0">
                <div class="menu-title-custom">
                  {{ $t("homeMenu.application") }}
                </div>
                <i class="icon-menu"></i>
              </li>

              <li class="nav-item menu-link-block">
                <a class="nav-link" href="#" @click.prevent="goSite('mailto:')" target="_blank">
                  <div class="menu-link-image">
                    <i class="fas fa-share"></i>
                  </div>
                  <div class="menu-link-title">
                    <p>
                      {{ $t("homeMenu.recommendFriend") }}
                    </p>
                  </div>
                </a>
              </li>

              <li class="nav-item menu-link-block">
                <a class="nav-link" href="#" @click.prevent="goSite('https://holacon.com/contact-us')" target="_blank">
                  <div class="menu-link-image">
                    <i class="fas fa-smile"></i>
                  </div>
                  <div class="menu-link-title">
                    <p>
                      {{ $t("homeMenu.sendFeedback") }}
                    </p>
                  </div>
                </a>
              </li>

              <li class="nav-item menu-link-block">
                <a class="nav-link" href="#" @click.prevent="goSite('https://holacon.com/contact-us')" target="_blank">
                  <div class="menu-link-image">
                    <i class="fas fa-star"></i>
                  </div>
                  <div class="menu-link-title">
                    <p>
                      {{ $t("homeMenu.rateUs") }}
                    </p>
                  </div>
                </a>
              </li>

              <li class="nav-item menu-link-block">
                <a class="nav-link" href="#" @click.prevent="goSite('https://holacon.com/product-guide')" target="_blank">
                  <div class="menu-link-image">
                    <i class="fas fa-life-ring"></i>
                  </div>
                  <div class="menu-link-title">
                    <p>
                      {{ $t("homeMenu.help") }}
                    </p>
                  </div>
                </a>
              </li>

              <li class="nav-item menu-link-block">
                <a class="nav-link" href="#" @click.prevent="goSite('https://holacon.com')" target="_blank">
                  <div class="menu-link-image-svg" style="background-image: url(/static/images/new-icons/holacon.svg)"></div>
                  <div class="menu-link-title">
                    <p>
                      {{ $t("homeMenu.checkHolacon") }}
                    </p>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Organization Create Dialog -->

    <el-dialog :title="$t('components.homeMenu.createOrganization')" :visible.sync="organizationDialog" class="medium" center modal-append-to-body destroy-on-close :close-on-click-modal="false" @close="resetFormBeforeClose">
      <div id="createevent-dialog" class="custom-modal">
        <div class="modal-body">
          <el-row :gutter="20" v-if="form">
            <el-col :span="24">
              <div class="custom-form-input-container">
                <div class="custom-label">
                  <label>
                    {{ $t("homeMenu.organizationName") }}
                  </label>
                </div>
                <el-input v-model="form.title" clearable :class="$inputError('title', validationErrors)"></el-input>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="custom-form-input-container">
                <div class="custom-label">
                  <label>
                    {{ $t("homeMenu.application") }}
                  </label>
                </div>
                <el-select v-model="form.defaultApplicationID" @clear="form.defaultApplicationID = null" clearable :class="$inputError('defaultApplicationID', validationErrors)">
                  <el-option v-for="(item, index) in applicationList" :key="'categories-type-' + index" :value="item.id" :label="item.title"></el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="custom-form-input-container">
                <div class="custom-label">
                  <label>
                    {{ $t("components.homeMenu.organizationType") }}
                  </label>
                  <el-tooltip :content="$t('homeMenu.userExpMsg')" placement="top">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-select v-model="form.categoryIds" multiple :class="$inputError('categoryIds', validationErrors)">
                  <el-option v-for="(item, index) in organizationCategories" :key="'categories-type-' + index" :value="item.id" :label="item.title"></el-option>
                </el-select>
              </div>
            </el-col>

            <el-col :span="24" v-if="organizationList.length == 0 && getEnums.length > 0">
              <div class="custom-form-input-container">
                <div class="custom-label">
                  <label>
                    {{ $t("homeMenu.questionFind") }}
                  </label>
                </div>
                <el-select v-model="form.whereDidYouFindUs" :class="$inputError('whereDidYouFindUs', validationErrors)">
                  <el-option v-for="(item, index) in getEnums.find(x => x.title == 'WhereDidYouFindUs').enums" :key="'WhereDidYouFindUs-type-' + index" :value="item.key" :label="item.displayName" clearable filterable></el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="modal-footer" slot="footer">
          <div class="left-buttons">
            <el-button @click="organizationDialog = false">{{ $t("homeMenu.cancel") }}</el-button>
          </div>
          <div class="right-buttons">
            <el-button type="secondary" @click="$helpMe('https://holacon.com/product-guide/detail/how-to-create-organization-on-event-planner-console')" icon="fas fa-life-ring">{{ $t("event.buttons.helpdesk") }}</el-button>
            <el-button type="primary" :loading="loading == 'createOrganization'" @click="createOrganization">{{ $t("homeMenu.create") }}</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="policyDialog" :title="policy != null ? policy.title : 'Sözleşme'" class="large" custom-class="agreement-dialog" :destroy-on-close="true" :close-on-click-modal="false">
      <div class="custom-modal">
        <div class="modal-body" v-html="policy.details"></div>
        <div class="modal-footer" slot="footer">
          <div class="left-buttons">
            <el-button @click="policyDialog = false">{{ $t("organisation.billing.close") }}</el-button>
          </div>
          <div class="right-buttons"></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import slugify from "slugify";

export default {
  name: "HomeMenu",

  data() {
    return {
      deleteDialog: false,
      deleteOrganization: {},
      deleteForm: {
        password: null,
        validationErrors: []
      },
      organizationDialog: false,
      form: {
        title: null,
        whereDidYouFindUs: null,
        categoryIds: [],
        defaultApplicationID: null
      },
      loading: false,
      policy: {},
      policyDialog: false,

      timeout: null,
      validationErrors: [],
      searchTerm: null
    };
  },

  async created() {
    await Promise.all([this.$store.dispatch("getEnums"), this.$store.dispatch("getCountries"), this.$store.dispatch("getOrganizationCategories"), this.$store.dispatch("getOrganizationList"), this.$store.dispatch("getWhiteLabelUserApplications")]);
  },
  methods: {
    async openAgreementDialog(type) {
      var res = await this.$store.dispatch("getPolicy", { type: type });
      if (!res.data.alert.hasError) {
        this.policy = res.data.data.item;
        this.policyDialog = true;
      }
    },
    goSite(url) {
      window.open(url, "_blank");
    },
    async createOrganization() {
      this.loading = "createOrganisation";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("createOrganization", this.form);
        this.validationErrors = res.data.validationErrors;
        if (!res.data.alert.hasError) {
          this.$message.success(res.data.alert.message);
          await this.switchOrganization(res.data.data.id);
          this.organizationDialog = false;
        } else {
          this.$message.error(res.data.alert.message);
        }
        this.loading = false;
      }, 500);
    },
    resetFormBeforeClose() {
      this.form = {
        title: null,
        whereDidYouFindUs: null,
        categoryIds: [],
        defaultApplicationID: null
      };
    },
    async switchOrganization(id) {
      console.log(id, "switchID");
      var res = await this.$client.post("Organization/SwitchOrganization", { id: id });
      if (!res.data.hasError) {
        this.$nextTick(async () => {
          this.$client.defaults.headers["Authorization"] = "Bearer " + res.data.data.token;
          this.$store.state.user.token = res.data.data.token;
          localStorage.setItem("token", res.data.data.token);
          await Promise.all([this.$store.dispatch("getOrganization"), this.$store.dispatch("getSubscriptionOverview"), this.$store.dispatch("getPaymentMethods")]);
        });
        this.$nextTick(() => {
          this.$router.push("/organisation/" + id).catch(() => {});
        });
      }
    }
  },
  mounted() {},
  watch: {
    "form.invoice.country": function() {
      var cityId = this.countryList.filter(x => x.title == this.form.invoice.country)[0];
      if (cityId) {
        this.$store.dispatch("getCities", cityId.id);
      }
    }
  },
  computed: {
    getSearchTerm() {
      return slugify(this.searchTerm == null ? "" : this.searchTerm, {
        replacement: " ",
        lower: true
      });
    },
    organizationListSearch() {
      var regex = new RegExp(this.getSearchTerm, "g");

      if (this.getSearchTerm == null || this.getSearchTerm == "") return this.organizationList;
      return this.organizationList.filter(
        k =>
          slugify(k.title, " ")
            .toLowerCase()
            .match(regex) || slugify(k.title, " ").match(regex)
      );
    },
    organizationCategories() {
      return this.$store.getters.getOrganizationCategories;
    },
    applicationList() {
      return this.$store.getters.getWhiteLabelApplicationList;
    },
    getEnums() {
      return this.$store.getters.getEnums;
    },
    countryList() {
      return this.$store.getters.getCountries;
    },
    cityList() {
      return this.$store.getters.getCities;
    },
    organizationList() {
      return this.$store.getters.getOrganizationList;
    },
    eventCategoriesList() {
      return this.$store.getters.getEventCategories;
    },
  }
};
</script>

<style lang="less">
.sidebar-xs {
  #home-menu {
    .menu-account-block {
      padding: 0px 6px;
      background-color: white;
      justify-content: center;

      .active {
        border: unset;

        &::after {
          display: none;
        }

        &::before {
          display: none;
        }
      }

      a {
        background-color: white;
        width: unset;
      }

      .menu-account-title {
        display: none;
      }
    }

    .menu-organisation-block {
      padding: 0px 6px;
      background-color: white;
      justify-content: center;

      .active {
        border: unset;

        &::after {
          display: none;
        }

        &::before {
          display: none;
        }
      }

      a {
        background-color: white;
        width: unset;

        &.create-organisation {
          height: 46px;
          margin-top: 10px;
          margin: 12px 8px;

          &::before {
            font-family: icomoon !important;
            font-style: normal;
            font-weight: 400;
            font-variant: normal;
            text-transform: none;
            line-height: 1;
            min-width: 1em;
            display: inline-block;
            text-align: center;
            font-size: 1rem;
            vertical-align: middle;
            position: relative;
            top: -1px;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            font-size: 16px;
            color: white;
            content: "\ED5A";
          }
        }
      }

      .menu-organisation-title {
        display: none;
      }
    }

    .menu-link-block {
      background-color: white;
      justify-content: center;

      a {
        background-color: white;
        justify-content: center;
      }

      .menu-link-title {
        display: none;
      }
    }
  }
}

#home-menu {
  background-color: #fff;
  border-right: 1px solid #f1f3f6;
  height: 100%;

  .menu-account-block {
    background-color: #fbfbfb;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    line-height: normal;

    .active {
      border-right: 4px solid #03658c;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;

      &::after {
        content: "";
        position: absolute;
        right: -1px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 8px 14px 8px 0;
        border-color: transparent #03658c transparent transparent;
      }

      &::before {
        content: "";
        position: absolute;
        right: -1px;
        width: 2px;
        height: 100%;
        background-color: #03658c;
      }
    }

    a {
      background: transparent;
      border-color: unset;
      border-color: unset;
      border: unset;
      height: auto;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 100%;

      .menu-account-image {
        width: 48px;
        min-width: 48px;
        aspect-ratio: 1;
        height: 48px;
        background-color: white;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        border-radius: 50%;
        border: 5px solid #efefef;
      }

      .menu-account-title {
        margin-left: 10px;

        p {
          font-size: 14px;
          font-weight: 600;
          color: #292f3b;
          margin: 0px;
          margin-bottom: 4px;
        }

        span {
          font-size: 13px;
          font-weight: 500;
          color: #505763;
          margin: 0px;
        }
      }
    }
  }
  .menu-organisation-list {
    background-color: #fbfbfb;
    position: relative;
    margin-bottom: 0px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    max-height: 400px;
    overflow: hidden;
    overflow-y: auto;

    &:not(:last-child) {
      border-bottom: 0.2px solid #f1f3f6;
    }
    & > .menu-organisation-item {
      background: transparent;
      border-color: unset;
      padding: 12px 20px;
      border-color: unset;
      border: unset;
      height: auto;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 100%;
      line-height: normal;

      &.active {
      border-right: 2px solid #03658c;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;

      span {
          color: #03658c !important;
          font-weight: 500 !important;
      }

      &::after {
        content: "";
        position: absolute;
        right: -1px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 8px 14px 8px 0;
        border-color: transparent #03658c transparent transparent;
      }

      &::before {
        content: "";
        position: absolute;
        right: -1px;
        width: 2px;
        background-color: #03658c;
      }
    }

      .menu-organisation-image {
        width: 48px;
        min-width: 48px;
        aspect-ratio: 1;
        height: 48px;
        background-color: white;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        border-radius: 12px;
        border: 5px solid #efefef;
      }

      .menu-organisation-title {
        margin-left: 10px;
        p {
          font-size: 14px;
          font-weight: 600;
          color: #292f3b;
          margin: 0px;
          margin-bottom: 4px;
        }

        span {
          font-size: 13px;
          font-weight: 500;
          color: #505763;
          margin: 0px;
        }
      }
      .el-button {
        margin-left: auto;
      }
    }
  }
  .menu-organisation-block {
    background-color: #fbfbfb;
    position: relative;
    margin-bottom: 0px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    &:not(:last-child) {
      border-bottom: 0.2px solid #f1f3f6;
    }

    .active {
      border-right: 4px solid #03658c;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;

      &::after {
        content: "";
        position: absolute;
        right: -1px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 8px 14px 8px 0;
        border-color: transparent #03658c transparent transparent;
      }

      &::before {
        content: "";
        position: absolute;
        right: -1px;
        width: 2px;
        height: 100%;
        background-color: #03658c;
      }
    }

    a {
      background: transparent;
      border-color: unset;
      border-color: unset;
      border: unset;
      height: auto;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 100%;
      gap: 10px;

      &.create-organisation {
        border-radius: 8px;
        background-color: #03658c !important;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 12px 8px;
        margin: 16px 8px;
        width: 100%;

        span {
          font-size: 14px;
          font-weight: 500;
          color: white;
        }
      }

      .menu-organisation-image {
        width: 48px;
        height: 48px;
        background-color: white;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        border-radius: 12px;
        border: 5px solid #efefef;
      }

      .menu-organisation-title {
        margin-left: 10px;

        p {
          font-size: 14px;
          font-weight: 600;
          color: #292f3b;
          margin: 0px;
        }

        span {
          font-size: 13px;
          font-weight: 500;
          color: #505763;
          margin: 0px;
        }
      }
    }
  }

  .menu-link-block {
    margin-bottom: 0px;

    &:last-child {
      a {
        border-bottom: unset;
      }
    }

    a {
      border-radius: 0px;
      padding: 14px 12px;
      height: auto;
      border-top: unset;
      border-right: unset;
      border-left: unset;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;

      .menu-link-image-svg {
        width: 28px;
        height: 28px;
        background-repeat: no-repeat;
        background-position: center center;
      }

      .menu-link-image {
        width: 28px;
        height: 28px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        i {
          font-size: 16px;
          color: #03658c !important;
          margin-right: unset !important;
        }
      }

      .menu-link-title {
        margin-left: 8px;

        p {
          font-size: 14px;
          font-weight: 500;
          color: #505763;
          margin: 0px;
        }
      }
    }
  }
}
.input-container-o {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
</style>

<style>
.sidebar-xs .menu-search-wrapper {
  display: none;
}

.sidebar-xs {
  transition: all 0.5s ease;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeMenu.vue